import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useStat } from "../../../DataStore/StatContext";
import { useCurrency } from "../../../util/SystemVariables";
import { Skeleton } from "../../../util/skeleton/Skeleton";

const nf = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });


export default function ProjectsHighlightsStrip() {
  const { getProjectStatList, projectStatList, loadingProjectStatList } = useStat();
  const currency = useCurrency();

  useEffect(() => {
    getProjectStatList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = useMemo(() => {
    if (!Array.isArray(projectStatList)) return [];
    // keep a few most relevant — show Active first, then On-Hold
    const sorted = [...projectStatList].sort((a, b) => {
      const sa = String(a.status || "").toLowerCase();
      const sb = String(b.status || "").toLowerCase();
      const wa = sa.includes("active") ? 0 : sa.includes("hold") ? 1 : 2;
      const wb = sb.includes("active") ? 0 : sb.includes("hold") ? 1 : 2;
      return wa - wb;
    });

    return sorted.slice(0, 6).map((p) => ({
      id: p.id,
      name: p.tag_name || "",
      code: p.project_code || "",
      status: p.status || "Active",
      budget: Number(p.budget_amount || 0),
      income: Number(p.financials?.total_income || 0),
      expense: Number(p.financials?.total_expense || 0),
      trend: Array.isArray(p.financials?.graph) ? p.financials.graph : [],
    }));
  }, [projectStatList]);

  const loading = loadingProjectStatList || (!projectStatList && projectStatList !== null);

  if(!projectStatList) return <></>

  return (
   <div className="yx-prjRailWrap mb-3">
  <div className="yx-prjRailHead">
    <div className="text-uppercase small text-muted">Projects</div>
   
    <Link to="/projects" className="rac-action">View all <i className="fa fa-arrow-right" /></Link>
  </div>

{/* <div className="yx-prjRail "> */}
<div 
          className="d-flex flex-nowrap overflow-auto hide-scrollbar py-0 px-4 horizontal-scroll-container" 
          style={{ gap: '20px', scrollSnapType: 'x mandatory', scrollBehavior: 'smooth', maxWidth: '65vw' }}
        >
  {loading && [...Array(4)].map((_, i) => (
    <div key={i} className="yx-prjChip" style={{ borderStyle: "dashed" }}>
      <div className="yx-prjChipLeft">
        <Skeleton w="60%" h={12} />
        <Skeleton w="85%" h={10} style={{ marginTop: 8 }} />
      </div>
      <div className="yx-prjChipRight">
        <Skeleton w="90px" h={12} />
        <Skeleton w="70px" h={22} style={{ marginTop: 8, borderRadius: 999 }} />
      </div>
    </div>
  ))}

  {!loading && items.map((p) => {
    const bal = (p.income - p.expense);
    const isActive = String(p.status || "").toLowerCase().includes("active");
    return (
      <div key={p.id} className="yx-prjChip">
        <div className="yx-prjChipLeft">
          <div className="yx-prjChipTop">
            <span className="yx-prjCode">{p.code || "—"}</span>
            <span className="yx-prjName" title={p.name}>{p.name}</span>
          </div>

          <div className="yx-prjMini" title={`Income ${p.income} • Expense ${p.expense}`}>
            Income {nf(p.income)} • Expense {nf(p.expense)}
          </div>
        </div>

        <div className="yx-prjChipRight">
          <div className={`yx-prjBal ${bal < 0 ? "is-negative" : ""}`}>
            {currency} {bal < 0 ? `(${nf(Math.abs(bal))})` : nf(bal)}
          </div>
          <span className={`yx-prjStatus ${isActive ? "is-active" : ""}`}>
            <i className="fa fa-circle" style={{ fontSize: 8, opacity: .7 }} />
            {p.status || "Active"}
          </span>
        </div>
      </div>
    );
  })}
</div>

</div>
  );
}

